"use strict";
import { useEffect } from "react";
import { KeyAction } from "utilities/src/device/keyboard/types";
export const useKeyDown = ({
  callback,
  keys,
  keyAction,
  disabled,
  preventDefault,
  shouldTriggerInInput = false
}) => {
  useEffect(() => {
    if (!keys || !keys.length || disabled) {
      return void 0;
    }
    const onKeyDown = (event) => {
      const wasAnyKeyPressed = keys.some((key) => event.key === key);
      const targetWasNotAnInput = event.target instanceof HTMLElement && !["input", "textarea"].includes(event.target?.tagName.toLowerCase());
      const shouldTrigger = wasAnyKeyPressed && (targetWasNotAnInput || shouldTriggerInInput);
      if (shouldTrigger) {
        if (preventDefault) {
          event.preventDefault();
        }
        callback(event);
      }
    };
    const keyActionType = keyAction || KeyAction.DOWN;
    document.addEventListener(keyActionType, onKeyDown);
    return () => {
      document.removeEventListener(keyActionType, onKeyDown);
    };
  }, [callback, keys, keyAction, disabled, preventDefault, shouldTriggerInInput]);
};
